import React from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { LoadingContext } from "../../../provider/MyContexts";

export default function LoadingBox() {
  const { loadingState } = useContext(LoadingContext);

  if (loadingState.type !== "box" || !loadingState.loading) {
    return <></>;
  }
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
      <Typography variant="body_M" marginTop={2}>
        {loadingState.content}
      </Typography>
    </Box>
  );
}

export function LoadingBox2(props: { text?: string }) {
  return (
    <Stack
      // flex={1}
      height="160px"
      sx={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
      <Typography marginTop={2} variant="label_M">
        {props.text}
      </Typography>
    </Stack>
  );
}
